/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/Distinct.ts
 * @create:      2025-06-26 14:08:32.387
 * @modify:      2025-07-11 21:19:12.919
 * @version:     6.0.0
 * @times:       16
 * @lines:       66
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ArrayDistinct } from "../array/ArrayDistinct";
import { StringDistinct } from "../string/StringDistinct";

/**
 * Returns a new string containing only the distinct characters from the input string,
 * preserving their original order of appearance.
 *
 * @param str - The input string from which to extract distinct characters.
 * @returns A string with duplicate characters removed.
 * 
 * @since 4.0.0
 * @version 2022-07-02
 */
export function Distinct(str: string): string;
/**
 * Returns a new array containing only the unique elements from the input array.
 *
 * @param array - The array from which to extract distinct elements.
 * @returns A new array with duplicate elements removed, preserving the order of first occurrence.
 * 
 * @since 4.0.0
 * @version 2022-07-02
 */
export function Distinct<T>(array: T[]): T[];
export function Distinct(val: string | unknown[]): string | unknown[] {
    if (Array.isArray(val)) {
        return ArrayDistinct(val);
    } else if (typeof val === "string") {
        return StringDistinct(val);
    } else {
        return val; // Return as is if not a string or array
    }
}
